import { render, staticRenderFns } from "./PriceChip.vue?vue&type=template&id=3b85ae44&scoped=true&"
import script from "./PriceChip.vue?vue&type=script&lang=js&"
export * from "./PriceChip.vue?vue&type=script&lang=js&"
import style0 from "./PriceChip.vue?vue&type=style&index=0&id=3b85ae44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85ae44",
  null
  
)

export default component.exports